import CartPresenter from './presenters/CartPresenter';
import '../../scss/cart.scss';

const BOLD = (window.BOLD = window.BOLD || {});
BOLD.BMS = BOLD.BMS || {};
BOLD.BMS.BUILDS = BOLD.BMS.BUILDS || {};
BOLD.BMS.BUILDS.CartPresenter = CartPresenter;

document.addEventListener('DOMContentLoaded', function(){
  BOLD.BMS.BUILDS.CartPresenter.init();
}, false);